<template>
    <kgr-input
        type="text"
        :model-value="currentValue"
        :label="label"
        :inline="inline"
        :error="error"
        :max-length="maxLength"
        :is-invalid="isInvalid"
        :disabled="disabled"
        @update:modelValue="onInput"
        @blur="$emit('blur', $event)"
    />
</template>

<script>
import Input from './Input';

export default {
    compatConfig: {
        MODE: 3,
    },

    components: {
        'kgr-input': Input,
    },
    props: {
        modelValue: {
            type: String,
            required: false,
            default: '',
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        maxLength: {
            type: Number,
            required: false,
        },
    },

    emits: ['update:modelValue', 'input', 'blur'],

    data() {
        return {
            currentValue: this.modelValue ?? this.value ?? '',
        }
    },

    watch: {
        modelValue(newValue) {
            this.currentValue = newValue;
        },
        value(newValue) {
            this.currentValue = newValue;
        }
    },

    methods: {
        onInput(value) {
            this.currentValue = value;
            this.$emit('update:modelValue', this.currentValue);

            // support legacy dependency on 'input' event
            this.$emit('input', this.currentValue);
            this.$nextTick(() => {
                this.$emit('post-input', this.currentValue);
            });
        }
    }
}
</script>
